import {Component, EventEmitter, Input, Output, ChangeDetectionStrategy} from '@angular/core';

@Component({
    selector: 'app-alert-sucesso-padrao',
    templateUrl: './alert-sucesso-padrao.component.html',
    styleUrls: ['./alert-sucesso-padrao.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager
})
export class AlertSucessoPadraoComponent {
  @Input() showSucesso: boolean;
  @Input() descricaoSucesso: any;
  @Output() alertSucessoFechou = new EventEmitter();

  constructor() { }

  fechaSucesso() {
  this.alertSucessoFechou.emit(true);
  }
}
